import styled from 'styled-components';

import { color } from 'theme/selectors';
import { mediaQueries } from 'theme/mediaQueries';

export const VideoWrapper = styled.video`
    border: 6px solid ${color('border-default')};
    border-radius: 20px;
    width: 190px;
    height: 397px;

    ${mediaQueries.tabletLandscape} {
        width: 217px;
        height: 456px;
    }
`;
